// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-dialog-container {
  width: 309px;
  height: 189px;
  opacity: 1;
  position: absolute;
  left: calc(50vw - 155px);
  top: calc(50vh - 95px);
  z-index: 10;
  animation: popup 0.1s ease-in-out 0s 1;
  border-radius: 5px;
}
.add-dialog-title {
  width: 120px;
  height: 20px;
  font-size: 18px;
  opacity: 1;
  width: 100%;
  text-align: center;
  font-weight: 500;
  margin-top: 15px;
}
.add-dialog-shelf-list-container {
  width: 100%;
  font-size: 15px;
  line-height: 14px;
  opacity: 1;
  margin-top: 15px;
  height: 30px;
}
.add-dialog-shelf-list-text {
  width: 50px;
  float: left;
  margin-left: 25px;
  margin-top: 7px;
}
.add-dialog-shelf-list-box {
  float: left;
  width: 210px;
  height: 31px;
  opacity: 1;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 31px;
  border-radius: 5px;
}
.add-dialog-shelf-list-option {
  width: 169px;
  height: 31px;
  opacity: 1;
  box-sizing: border-box;
  margin-left: 16px;
  font-size: 15px;
  line-height: 31px;
  cursor: pointer;
  text-align: left;
}
.add-dialog-new-shelf-text {
  width: 50px;
  float: left;
  margin-left: 25px;
  margin-top: 7px;
}
.add-dialog-new-shelf-box {
  float: left;
  width: 210px;
  height: 31px;
  opacity: 1;
  box-sizing: border-box;
  padding-left: 5px;
  font-size: 15px;
  line-height: 31px;
  border-radius: 5px;
}
.add-dialog-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  position: absolute;
  right: 25px;
  bottom: 15px;
}
.add-dialog-cancel {
  min-width: 60px;
  height: 26px;
  opacity: 1;
  /* position: absolute;
  left: 147px;
  top: 144px; */
  border-radius: 5px;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
  margin-right: 10px;
  line-height: 26px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
}
.add-dialog-confirm {
  min-width: 64px;
  height: 30px;
  opacity: 1;

  font-size: 13px;
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 30px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/addDialog/addDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV;;eAEa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;;EAEV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".add-dialog-container {\n  width: 309px;\n  height: 189px;\n  opacity: 1;\n  position: absolute;\n  left: calc(50vw - 155px);\n  top: calc(50vh - 95px);\n  z-index: 10;\n  animation: popup 0.1s ease-in-out 0s 1;\n  border-radius: 5px;\n}\n.add-dialog-title {\n  width: 120px;\n  height: 20px;\n  font-size: 18px;\n  opacity: 1;\n  width: 100%;\n  text-align: center;\n  font-weight: 500;\n  margin-top: 15px;\n}\n.add-dialog-shelf-list-container {\n  width: 100%;\n  font-size: 15px;\n  line-height: 14px;\n  opacity: 1;\n  margin-top: 15px;\n  height: 30px;\n}\n.add-dialog-shelf-list-text {\n  width: 50px;\n  float: left;\n  margin-left: 25px;\n  margin-top: 7px;\n}\n.add-dialog-shelf-list-box {\n  float: left;\n  width: 210px;\n  height: 31px;\n  opacity: 1;\n  box-sizing: border-box;\n  font-size: 15px;\n  line-height: 31px;\n  border-radius: 5px;\n}\n.add-dialog-shelf-list-option {\n  width: 169px;\n  height: 31px;\n  opacity: 1;\n  box-sizing: border-box;\n  margin-left: 16px;\n  font-size: 15px;\n  line-height: 31px;\n  cursor: pointer;\n  text-align: left;\n}\n.add-dialog-new-shelf-text {\n  width: 50px;\n  float: left;\n  margin-left: 25px;\n  margin-top: 7px;\n}\n.add-dialog-new-shelf-box {\n  float: left;\n  width: 210px;\n  height: 31px;\n  opacity: 1;\n  box-sizing: border-box;\n  padding-left: 5px;\n  font-size: 15px;\n  line-height: 31px;\n  border-radius: 5px;\n}\n.add-dialog-button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  position: absolute;\n  right: 25px;\n  bottom: 15px;\n}\n.add-dialog-cancel {\n  min-width: 60px;\n  height: 26px;\n  opacity: 1;\n  /* position: absolute;\n  left: 147px;\n  top: 144px; */\n  border-radius: 5px;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: 13px;\n  margin-right: 10px;\n  line-height: 26px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n}\n.add-dialog-confirm {\n  min-width: 64px;\n  height: 30px;\n  opacity: 1;\n\n  font-size: 13px;\n  border-radius: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  line-height: 30px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
